import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom'; // Importar useNavigate
import './ResetPassword.css';
import Navbar from './Navbar';
import Footer from './Footer';
import log from './services/logService';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false); // Adicionar estado para sucesso/erro
  const navigate = useNavigate(); // Hook para navegação

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Limpa a mensagem anterior
    setIsSuccess(false);

    // Validação básica da senha no frontend (opcional, mas recomendada)
    if (newPassword.length < 8 || !/\d/.test(newPassword) || !/[a-zA-Z]/.test(newPassword)) {
        setMessage("A senha deve ter no mínimo 8 caracteres alfanuméricos.");
        setIsSuccess(false);
        return;
    }

    if (!token) {
        setMessage('Token de redefinição inválido ou ausente.');
        setIsSuccess(false);
        return;
    }

    try {
      // Usar a variável de ambiente correta que você definiu
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL_RESET_PASSWORD}`, { token, newPassword });

      log('Resposta completa do Axios:', response);
      log('Dados da resposta (response.data):', response.data);

      let data; // Variável para guardar o objeto { success, message } final

      // --- LÓGICA CONDICIONAL PARA ESTRUTURA DA RESPOSTA ---

      // 1. Verifica se tem a estrutura de Produção (API Gateway Proxy)
      if (response.data && typeof response.data.body === 'string') {
        log('Detectada estrutura de Produção (API Gateway Proxy).');
        try {
          data = JSON.parse(response.data.body);
        } catch (parseError) {
          log('Erro ao fazer parse do response.data.body:', parseError);
          setMessage('Erro ao processar a resposta do servidor (formato body inválido).');
          setIsSuccess(false);
          return; // Sai da função se o parse falhar
        }
      }
      // 2. Verifica se tem a estrutura Local (objeto direto)
      else if (response.data && typeof response.data.success === 'boolean') {
        log('Detectada estrutura Local (objeto direto).');
        data = response.data;
      }
      // 3. Se nenhuma das estruturas acima for encontrada
      else {
        log('Estrutura de resposta inesperada:', response.data);
        setMessage('Erro ao processar a resposta do servidor (formato inesperado).');
        setIsSuccess(false);
        return; // Sai da função
      }

      // --- PROCESSA O OBJETO 'data' OBTIDO ---
      log('Dados processados:', data);

      // Verifica se 'data' é válido e tem a propriedade 'success'
      if (data && typeof data.success !== 'undefined') {
        setMessage(data.message || (data.success ? 'Senha redefinida com sucesso!' : 'Falha ao redefinir senha.'));
        setIsSuccess(data.success);

        // Opcional: Redirecionar para o login após sucesso
        if (data.success) {
          setTimeout(() => {
            navigate('/dashboard'); // Redireciona para a página de login após 3 segundos
          }, 1000);
        }

      } else {
        // Caso data seja inválido após as verificações
        log('Objeto de dados final inválido após processamento:', data);
        setMessage('Erro ao interpretar os dados da resposta do servidor.');
        setIsSuccess(false);
      }

    } catch (error) {
      log('Erro no handleSubmit (catch geral):', error);

      // Mantém o tratamento detalhado de erros do Axios
      if (error.response) {
        log('Erro - Resposta do servidor:', error.response.data);
        log('Erro - Status do servidor:', error.response.status);
        log('Erro - Cabeçalhos do servidor:', error.response.headers);

        let errorMsg = `Erro do servidor: ${error.response.status}.`;
        // Tenta extrair a mensagem de erro da resposta, similar ao ForgotPassword
        if (error.response.data) {
            if (typeof error.response.data === 'string') {
                try {
                    const parsedErrorBody = JSON.parse(error.response.data);
                    errorMsg = parsedErrorBody.message || errorMsg;
                } catch { /* Ignora erro de parse */ }
            } else if (error.response.data.message) {
                errorMsg = error.response.data.message;
            }
        }
        setMessage(`${errorMsg} Verifique o console.`);

      } else if (error.request) {
        log('Erro - Sem resposta:', error.request);
        setMessage('Erro de rede ou CORS. Verifique a conexão e a configuração do servidor.');
      } else {
        log('Erro - Configuração da requisição:', error.message);
        setMessage(`Erro ao configurar a requisição: ${error.message}`);
      }
      setIsSuccess(false); // Garante que isSuccess seja false no catch
    }
  };

  return (
    <div>
      <Navbar />
      <div className="reset-password-container">
        <div className="logo-container">
          <img src="./logo.webp" alt="QR Code Brasil" />
        </div>
        <h1>Redefinir Senha</h1>
        {!token && <div className="error-message">Token de redefinição não encontrado na URL.</div>}
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="password"
              id="new-password" // Adiciona ID para o label
              placeholder=" " // Placeholder para label flutuante
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={!token} // Desabilita se não houver token
            />
            <label htmlFor="new-password">Nova Senha</label> {/* Usa htmlFor */}
            {/* Exibe a mensagem abaixo do input */}
            {message && (
              <div className={`message-display ${isSuccess ? 'success-message' : 'error-message'}`}>
                {message}
              </div>
            )}
          </div>
          <button type="submit" disabled={!token}>Redefinir</button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
